import { JobQualificationsView, LayoutContainer } from "@relode/core";
import * as React from "react";

import { useClientPublicJobContext } from "../_infra/clientPublicJobProvider";

export const ClientPublicJobQualifications = () => {
    const {
        state: {
            data: {
                job: { qualifications },
            },
        },
    } = useClientPublicJobContext();
    return (
        <LayoutContainer>
            <JobQualificationsView qualifications={qualifications} />
        </LayoutContainer>
    );
};
